export default "<civcast-aws-uploader (selectedFiles)=\"setSelectedFiles($event)\" [allowDragDrop]=\"true\"></civcast-aws-uploader>\n"